import { useCallback } from 'react'
import { useLocale } from './LocaleProvider'

/**
 * Returns `localized(path)` which prefixes an internal absolute path with the
 * active locale (`/encyclopedia` → `/en/encyclopedia`). Pass-throughs: external
 * URLs, protocol-relative, `mailto:`, hash-only, relative paths, and paths
 * already prefixed with the active locale.
 */
export function useLocalizedHref(): (to: string) => string {
  const { locale } = useLocale()
  return useCallback(
    (to: string): string => {
      if (!to) return to
      if (/^[a-z][a-z0-9+.-]*:/i.test(to) || to.startsWith('//') || to.startsWith('#')) return to
      if (!to.startsWith('/')) return to // relative — leave as-is
      if (to === `/${locale}` || to.startsWith(`/${locale}/`)) return to // already localized
      return to === '/' ? `/${locale}` : `/${locale}${to}`
    },
    [locale],
  )
}
